export const removeItem = (listOfTests, itemToBeRemovedTest) =>{
  return  listOfTests.filter(test => test.specimen_id !== itemToBeRemovedTest);
}

export default removeItem;